module.exports = __webpack_public_path__ + "images/arrowright895723499e5dc0eed7f5dfa0acae392a.svg";